import { useState, useEffect } from 'react';
import { ACCESS_KEY, TEMP, PHOTO, AMAZON_UPLOAD_TEMP, OUTPUT, UGCS, UGCS_TEMP, API_SERVERLESS_ENDPOINT } from '../../../app.config';
import * as Evaporate from 'evaporate';
import SparkMD5 from 'spark-md5';


const bucketMap = {
    temp: TEMP,
    photo: PHOTO,
    videoUpload: AMAZON_UPLOAD_TEMP,
    video: OUTPUT,
    ugcs: UGCS,
    ugcsTemp: UGCS_TEMP
}

const useEvaporateService = (props: any, bucket?) => {
    const [fileName, setFileName] = useState()
    const [isTrue, setIsTrue] = useState(false)
    useEffect(() => {
        if (fileName !== props?.file?.name) {
            setFileName(props.file.name)
            setIsTrue(true);
        }
    }, [fileName, props])

    if (props && isTrue) {
        let {
            file,
            ...other
        } = props

        const xAmzHeadersAtInitiate = {
            'x-amz-acl': 'public-read'
        }

        let config = {
            signerUrl: `${API_SERVERLESS_ENDPOINT}/amazon/sign-auth`,
            aws_key: ACCESS_KEY,
            bucket: bucket ? bucketMap[bucket] : bucketMap['video'],
            awsSignatureVersion: '2',
            retryBackoffPower: 20,
            allowS3ExistenceOptimization: true,
            computeContentMd5: true,
            s3FileCacheHoursAgo: 5,
            cryptoMd5Method: function (data) {
              return btoa(SparkMD5.ArrayBuffer.hash(data, true));
            },
            logging: process.env.REACT_NODE_ENV_TYPE !== 'prod',
            s3Acceleration: true,
        }

        Evaporate.create(config)
            .then((evaporate: any) => {
                evaporate.add({ file, xAmzHeadersAtInitiate, ...other });
            });

        setIsTrue(false)
    }
}

export default useEvaporateService